import e from"styled-components";const i=e.div`
	display: grid;
	place-content: center;
	width: ${({size:e})=>e};
	height: ${({size:e})=>e};

	svg {
		width: ${({size:e})=>e};
		height: ${({size:e})=>e};
	}
`;export{i as IconContainer};
